import React, { useEffect, useState } from "react";
import request from "../../../Helpers/API";
import { useHistory } from "react-router-dom";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { LoaderScreen } from "../../components/LoaderScreen";
import { TextField, Button } from "@mui/material";
import { useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";

export const DetalleBuroCredito = () => {
  const history = useHistory();
  const [data, setData] = useState([]);
  const [data2, setData2] = useState([]);
  const [comment, setComment] = useState("");
  const location = useLocation();
  const clientInfo = location.state.clientInfo;
  const infoFiltro = JSON.parse(localStorage.getItem("filtroEstado"));
  const [totalSaldoVencido, setTotalSaldoVencido] = useState(0);
  const [totalSaldoPorVencer, setTotalSaldoPorVencer] = useState(0);
  const [btnMarcar, setBtnMarcar] = useState(false);
  const handleCancel = () => {
    history.goBack();
  };
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });
  // console.log(clientInfo)

  const onGuardar = () => {
    setLoader({ ...loader, mostrar: true });

    const mdl = {
      idcliente: clientInfo.idcliente,
      comentarios: comment,
      usuario: "9035",
    };

    request
      .post(`GuardaClienteBuroComentarios/Guardar`, mdl)
      .then((response) => {
        setLoader({ ...loader, mostrar: false });
        history.goBack();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
      });
  };

  const handleCargarDetalleVencido = () => {
    // setLoader({ ...loader, mostrar: true });
    return new Promise((resolve, reject) => {
      request
        .get(
          `CargaDetalleBuro/Cargar_Vencido?ejercicio=${infoFiltro.ejercicio}&periodo=${infoFiltro.periodo}&idCliente=${clientInfo.idcliente}`
        )
        .then((result) => {
          //   setLoader({ ...loader, mostrar: false });
          setData(result);
          resolve("");
          return;
        })
        .catch((error) => {
          reject(error);
          return;
          //   setLoader({ ...loader, mostrar: false });
        });
    });
  };

  const handleCargarDetallePorVencer = () => {
    // setLoader({ ...loader, mostrar: true });
    return new Promise((resolve, reject) => {
      request
        .get(
          `CargaDetalleBuro/Cargar_porVencer?ejercicio=${infoFiltro.ejercicio}&periodo=${infoFiltro.periodo}&idCliente=${clientInfo.idcliente}`
        )
        .then((result2) => {
          // setLoader({ ...loader, mostrar: false });
          setData2(result2);
          resolve("");
          return;
        })
        .catch((error) => {
          reject(error);
          return;
          // setLoader({ ...loader, mostrar: false });
        });
    });
  };

  const handleDesmarcar = () => {
    // setLoader({ ...loader, mostrar: true });
    return new Promise((resolve, reject) => {
      request
        .get(`DesmarcarClienteBuro/desmarcar?idCliente=${clientInfo.idcliente}`)
        .then((result) => {
          history.goBack();
          return;
        })
        .catch((error) => {
          reject(error);
          return;
          // setLoader({ ...loader, mostrar: false });
        });
    });
  };

  const handleCargarComentarios = () => {
    setLoader({ ...loader, mostrar: true });
    return new Promise((resolve, reject) => {
      request
        .get(
          `CargaClientesBuroComentario/Cargar_Comentario?idCliente=${clientInfo.idcliente}`
        )
        .then((response) => {
          if (response.length > 0) {
            const { comentarios } = response[0];
            setComment(comentarios);
            setBtnMarcar(true);
          } else {
            setComment("");
            setBtnMarcar(false);
          }
          setLoader({ ...loader, mostrar: false });
          resolve("");
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          reject(error);
        });
    });
  };

  useEffect(() => {
    if (clientInfo.registrado == 0) {
      mostrarAlerta();
    } else {
      setLoader({ ...loader, loader: true });
      request
        .get(
          `CargaDetalleBuro/Cargar_Vencido?ejercicio=${infoFiltro.ejercicio}&periodo=${infoFiltro.periodo}&idCliente=${clientInfo.idcliente}`
        )
        .then((result) => {
          // console.table(result.operacion);
          setData(result.operacion);
          setData2(result.revolvente);
          handleCargarComentarios();
          setLoader({ ...loader, mostrar: false });
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          Swal.fire("BURO DE CREDITO", JSON.stringify(error), "error");
        });
    }
  }, []);

  const mostrarAlerta = () => {
    Swal.fire(
      "CREDITO Y COBRANZA",
      "EL CLIENTE NO SE ENCUENTRA REGISTRADO. <br/> NO SE ENCONTRÓ INFORMACIÓN PARA MOSTRAR.",
      "error"
    ).then((result) => {
      if (result.isConfirmed || result.isDismissed) {
        history.goBack();
      }
    });
  };

  const calcularTotalSaldoVencido = () => {
    const total = data.reduce((accumulator, item) => {
      return (
        accumulator +
        ((item.saldo_operacion || 0) + (item.saldo_revolvente || 0))
      );
    }, 0);
    setTotalSaldoVencido(total);
  };

  const calcularTotalSaldoPorVencer = () => {
    const total = data2.reduce((accumulator, item) => {
      return (
        accumulator +
        ((item.saldo_operacion || 0) + (item.saldo_revolvente || 0))
      );
    }, 0);
    setTotalSaldoPorVencer(total);
  };

  useEffect(() => {
    calcularTotalSaldoVencido();
  }, [data]);

  useEffect(() => {
    calcularTotalSaldoPorVencer();
  }, [data2]);

  const getLineaCreditoTexto = (lineaCredito) => {
    switch (lineaCredito) {
      case "O":
        return "OPERACION";
      case "R":
        return "REVOLVENTE";
      default:
        return "";
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const getSaldo = (item) => {
    switch (item.linea_credito) {
      case "O":
        return FormatMoney(item.saldo_operacion);
      case "R":
        return FormatMoney(item.saldo_revolvente);
      default:
        return "";
    }
  };
  const onImprimirArchivo = (folio) => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(
        `SolicitudCreditoDocumentacion/ObtenerDocumento?folio=${folio}&iddocumento=${Number(
          25
        )}`
      )
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        const linkSource = result.comentarios;
        const downloadLink = document.createElement("a");
        const fileName = `${result.documento}.${result.extension}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "ANALISIS DE SOLICITUD DE CREDITO",
          JSON.stringify(error),
          "error"
        );
      });
  };
  return (
    <PlantillaScreen
      titulo={"DETALLE DE " + clientInfo.razonsocial}
      className_main={1}
      className={"detalle-burocliente"}
    >
      <LoaderScreen loader={loader} />
      <div className="detalle-container">
        <div className="factura-vencidas">
          <h3>Crédito MHUSA</h3>
          <div className="tabla-vencida scroll-4">
            <table>
              <thead>
                <tr>
                  <td></td>
                  <td>Línea de Crédito</td>
                  <td>Fecha</td>
                  <td>Vencimiento</td>
                  <td>Saldo</td>
                  <td>Pedido</td>
                </tr>
              </thead>
              <tbody>
                {data.map((item) => (
                  <tr>
                    <td>
                      {item.clave === true && (
                        <div className="circle-red-td"></div>
                      )}
                    </td>
                    <td>{getLineaCreditoTexto(item.linea_credito)}</td>
                    <td className="ta-center">
                      {formatDate(item.fecha_factura)}
                    </td>
                    <td className="ta-center">
                      {formatDate(item.fecha_vencimiento)}
                    </td>
                    <td className="ta-right">{getSaldo(item)}</td>
                    <td>
                      {item.folio_solicitud != "" && (
                        <div
                          className={"analisis-credito-modal-mhusa-content-pdf"}
                          onClick={() => onImprimirArchivo(item.folio_soliitud)}
                        >
                          <CloudDownloadIcon />
                          <div>Descargar</div>
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
                <tr>
                  <td colSpan="5">Saldo Total:</td>
                  <td className="saldo-total">
                    {FormatMoney(totalSaldoVencido)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="factura-por-vencer">
          <h3>Crédito Revolvente</h3>
          <div className="tabla-por-vencer scroll-4">
            <table>
              <thead>
                <tr>
                  <td>Línea de Crédito</td>
                  <td>Fecha</td>
                  <td>Vencimiento</td>
                  <td>Saldo</td>
                </tr>
              </thead>
              <tbody>
                {data2.map((item) => (
                  <tr>
                    <td>{getLineaCreditoTexto(item.linea_credito)}</td>
                    <td className="ta-center">{formatDate(item.fecha_factura)}</td>
                    <td className="ta-center">{formatDate(item.fecha_vencimiento)}</td>
                    <td>{getSaldo(item)}</td>
                  </tr>
                ))}
                <tr>
                  <td colSpan="2">Saldo Total:</td>
                  <td colSpan="3" className="saldo-total">
                    {FormatMoney(totalSaldoPorVencer)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="comentarios">
          <h3>Comentarios</h3>
          <TextField
            label="Comentario"
            multiline
            value={comment}
            variant="outlined"
            onChange={(event) => setComment(event.target.value)}
            fullWidth
            className="comentario-textfield"
          />
        </div>

        <div className="botones">
          <Button variant="contained" color="secondary" onClick={handleCancel}>
            Regresar
          </Button>
          {btnMarcar === true ? (
            <Button
              className="boton-desmarcar"
              variant="contained"
              color="primary"
              onClick={handleDesmarcar}
            >
              Desmarcar
            </Button>
          ) : (
            <Button variant="contained" color="primary" onClick={onGuardar}>
              Marcar
            </Button>
          )}
        </div>
      </div>
    </PlantillaScreen>
  );
};
